import { useTranslation } from '@aimsos/i18n';

import { EmptyState } from '../states/index.js';

import { Unlink } from 'lucide-react';

/**
 * What the profile slide-out says when the item a link names cannot be shown:
 * an unknown or reserved kind, an item that no longer exists, or one the viewer
 * may not open (CT-5715). One message for all three — none of them is the
 * user's to fix from here.
 */
function ItemUnavailableState() {
  const { t } = useTranslation('unified-profiles');

  return (
    <EmptyState
      testId="item-unavailable"
      icon={Unlink}
      title={t('itemSlideOut.unavailable.title')}
      subtitle={t('itemSlideOut.unavailable.subtitle')}
    />
  );
}

export default ItemUnavailableState;
